import { TurnstileModes, TurnstileModeValues } from "@/types/turnstile"

import { env } from "@/lib/env"

export const TURNSTILE_ERROR_INVALID_SITE_KEY = "110100"
export const TURNSTILE_ERROR_SITE_KEY_NOT_FOUND = "110110"
export const TURNSTILE_ERROR_DOMAIN_NOT_AUTHORIZED = "110200"
export const TURNSTILE_ERROR_CHALLENGE_TIMEOUT = "110600"
export const TURNSTILE_ERROR_INTERACTION_TIMEOUT = "110620"
export const TURNSTILE_ERROR_CLOCK_OR_CACHE = "200100"
export const TURNSTILE_ERROR_IFRAME_LOAD = "200500"
export const TURNSTILE_ERROR_INVALID_SITE_KEY_CONFIGURATION = "400020"
export const TURNSTILE_ERROR_SITE_KEY_DISABLED = "400070"
export const TURNSTILE_ERROR_GENERIC_CLIENT_PREFIX = "300"
export const TURNSTILE_ERROR_CHALLENGE_EXECUTION_PREFIX = "600"

export type TurnstileErrorAction = "reset" | "retry" | "terminal"

export function buildTurnstileError(errorCode: string): Error {
  const error = new Error(`[Cloudflare Turnstile] Error: ${errorCode}.`)
  error.name = "TurnstileError"
  return error
}

export function turnstileErrorAction(errorCode: string): TurnstileErrorAction {
  if (errorCode === TURNSTILE_ERROR_INTERACTION_TIMEOUT) {
    return "reset"
  }

  // Cloudflare documents 300*** and 600*** as automatic-retry families. A
  // complete client error code is six digits; partial or extended values are
  // not members of either family.
  // https://developers.cloudflare.com/turnstile/troubleshooting/client-side-errors/error-codes/
  const isAutomaticRetryFamily =
    /^\d{6}$/.test(errorCode) &&
    (errorCode.startsWith(TURNSTILE_ERROR_GENERIC_CLIENT_PREFIX) ||
      errorCode.startsWith(TURNSTILE_ERROR_CHALLENGE_EXECUTION_PREFIX))

  if (
    errorCode === TURNSTILE_ERROR_CHALLENGE_TIMEOUT ||
    errorCode === TURNSTILE_ERROR_IFRAME_LOAD ||
    isAutomaticRetryFamily
  ) {
    return "retry"
  }

  return "terminal"
}

export function turnstileMode(): TurnstileModes {
  if (!env("NEXT_PUBLIC_CF_TURNSTILE_SITE_KEY")) {
    return "none"
  }
  const value = env("NEXT_PUBLIC_CF_TURNSTILE_MODE") as
    | TurnstileModes
    | undefined
  return value && TurnstileModeValues.includes(value) ? value : "none"
}

export function shouldTurnstile(formType: "sign-in" | "register"): boolean {
  if (turnstileMode() === "sign-in") {
    return true
  }

  if (turnstileMode() === "register") {
    return formType === "register"
  }

  return false
}
